<script lang="ts">
  import { Col, Form, FormGroup, Input, Label, Row } from "sveltestrap";
  import { UploadYourFiles } from "../../../../utils/Constant/Constant";
  import { updloadfiledata } from "../../../../Data/Miscellaneous/CardView";
</script>

<h6 class="mb-0">{UploadYourFiles}</h6>
<Form class="theme-form">
  {#each updloadfiledata as fileItem}
    <Row>
      <Col>
        <FormGroup>
          <Label class="col-form-label pt-0">{fileItem}:
            <span class="font-danger">*</span>
          </Label>
          <Input type="file" />
        </FormGroup>
      </Col>
    </Row>
  {/each}
</Form>
